exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".candidate-right .el-tag{margin:0 5px 5px 0}.tabbox .el-checkbox{color:#333}.tabbox .el-checkbox__inner{width:20px;height:20px;border-radius:50%}.tabbox .el-checkbox__inner:after{left:7px;top:4px}.el-checkbox__input.is-checked+.el-checkbox__label{color:#333}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-27afad3d","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./src/packages/candidate/um-candidate.vue
// module id = 78
// module chunks = 0